export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String | Object,
      default: ''
    },
    options: {
      type: Array,
      default: () => [
        { name: 'one_way', label: 'one_way', show: true },
        { name: 'round_trip', label: 'round_trip', show: true },
        { name: 'multicity', label: 'multicity', show: false }
      ]
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value.selectedValue || this.value
      },
      set(newValue) {
        this.$emit('input', {
          selectedValue: newValue,
          isRoundtrip: newValue === 'round_trip',
          isOneWay: newValue === 'one_way',
          isMulticity: newValue === 'multicity'
        })
      }
    },
    filteredOptions: function () {
      return this.options.filter((option) => option.show )
    },
  },
  watch: {
    internalValue: {
      handler(newValue) {
        if (newValue.selectedValue !== this.internalValue) {
          this.internalValue = newValue.selectedValue || newValue
        }
      },
      immediate: true
    }
  }
}